import { useQuery } from '@tanstack/react-query';
import { INSTANCE_CONFIG_KEY } from '../../utils/constants/queryKeys';
import { getInstanceConfig } from '../services/fn-api/Common';

export const useGetInstanceConfig = () => {
  return useQuery({
    queryKey: [INSTANCE_CONFIG_KEY],
    queryFn: () => getInstanceConfig(),
  });
};
